export default "__VITE_ASSET__nvrpNmMG__"